<template>
  <button
    type="button"
    class="btn"
    v-bind:class="classObject"
    @click="$listeners.click || onClick"
    :disabled="disabled"
    @mouseover="mouseOver($event)"
    @mouseleave="mouseOut($event)"
  >
    {{ getTitle }}
  </button>
</template>
<script>
//    v-tooltip.notrigger="{content: tooltipContent, visible: tooltipVisibility}"
import modelMixin from '../mixins/modelMixin';

const bootstrapColors = ['default', 'primary', 'success', 'info', 'danger', 'warning', 'link'];

export default {
  name: 'w-button',
  props: {
    small: {type: Boolean, default: false},
    large: {type: Boolean, default: false},
    color: {type: String, default: 'defult'}
  },

  mixins: [modelMixin],
  data() {
    return {};
  },
  computed: {
    classObject() {
      const result = [];
      if (bootstrapColors.includes(this.color)) {
        result.push('btn-' + this.color);
      } else {
        result.push(this.color);
      }
      if (this.disabled) {
        result.push('disabled');
      }
      return result;
    }
  },
  methods: {
    onClick() {
      this.$emit('click');
    }
  }
};
</script>
